import { gql } from '@apollo/client'

export const CompleteMultipartUpload = gql`
    mutation CompleteMultipartUpload($uploadId: ID!, $hash: String!, $parts: [MultipartUploadPartInput!]!) {
        completeMultipartUpload(uploadId: $uploadId, hash: $hash, parts: $parts)
    }
`

export default CompleteMultipartUpload
